import "./WhyWeSection.scss";
import Button from "components/Button/Button";
import Cards from "components/Cards/Cards";
import { getWhyWeReasons } from "../../constants/whyWeReasons";
import { scrollToSection } from "utils/scroll";
import { useTranslation } from "react-i18next";

const WhyWeSection = () => {
  const { t } = useTranslation();
  return (
    <div className="why-we-container" id="why-we">
      <h2 className="main-title">{t("titles.whyWe")}</h2>
      <div className="sub-title title-border">
        {t("subtitles.whyWeSubtitle1")}
      </div>
      <div className="sub-title">{t("subtitles.whyWeSubtitle2")}</div>
      <Cards cardsArr={getWhyWeReasons().cards} />
      <Button
        className={"blue-btn"}
        btnName={t("buttons.startNow")}
        onClick={() => {
          scrollToSection("home");
        }}
      />
    </div>
  );
};
export default WhyWeSection;
